export default "/fonts/vendor/primeicons/primeicons.svg?6ed59f962963a4a73af29e6b472608ab";